module.exports = __webpack_public_path__ + "img/3.bde8490e.jpg";